import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ServiceService } from '../services/service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],

})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  hide = true;
  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private service:ServiceService
  ) {
    this.loginForm = this.fb.group({
      mobileNumber: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }
  public isVisible: boolean = false;
  ngOnInit() { }

  get mobileNumber() {
    return this.loginForm.get('mobileNumber');
  }
  q = {
    mobileNumber: '',
    password: ''
  }
  get password() {
    return this.loginForm.get('password');
  }
  fail_mgs = ''; fail_show = false;

  login(form) {
    console.log("form",form)
    this.service.userLogin(form)
      .subscribe(
        (response: any) => {
          console.log(response)
          if (response.status == "success") {
            sessionStorage.setItem('token', response.oAuthId);
            sessionStorage.setItem('userType', response.userType);
            sessionStorage.setItem('userId', response.userId);
          
          
             sessionStorage.setItem('name', response.firstName + ' ' + response.lastName);
         
            sessionStorage.setItem('token', response.result.oAuthId);
          //  this.service.setLoginData('login')

            this.router.navigate(['/overview']);
          } else {
            // alert(response.message);
            this.fail_mgs = response.message;
            this.fail_show = true;
          }
          if (this.isVisible) { 
            return;
          } 
          this.isVisible = true;
          setTimeout(()=> this.isVisible = false,5500)
        })
  }

  // forgotPassword() {
  //   let dialogRef = this.dialog.open(ForgotPasswordComponent, {
  //     width: "450px",
  //     height: "400px",
  //     disableClose: true,
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
   
  //     if (result === 1) {

  //     }
  //   });
  // }
}
